// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.score-panel[data-v-5cd84645] {\n\tborder-right: 1px solid #d5d5d5;\n\tposition: relative;\n\tpadding-right: 10px;\n}\n.column-tooltip[data-v-5cd84645] {\n\tpadding-right: 1em;\n}\n.tooltip[data-v-5cd84645] {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n}\n.is-dashed[data-v-5cd84645] {\n\tborder-bottom: none;\n}\n", ""]);
// Exports
module.exports = exports;
